(function ($) {
  Drupal.behaviors.basicBackgroundMediaV1 = {
    attach: function (context) {
      var self = this;
      var $modules = $('.js-basic-background-media', context);

      $.each($modules, function () {
        var $module = $(this);
        var $content = $module.find('.js-basic-background-media__content');
        var $video = $module.find('video');
        var $items = $content.children('.js-basic-background-media__content-item');
        var inlineWidths = $content.data('inline-widths');

        // To be depreciated
        if (inlineWidths) {
          self.applyInlineWidths(inlineWidths, $items);
        }
        if ($video && $video.length > 0) {
          if ($video.parent().parent('.basic-background-media__container')) {
            $video
              .parent()
              .parent('.basic-background-media__container')
              .addClass('video-background');
          }
        }
      });
    },
    // To be depreciated
    applyInlineWidths: function (inlineWidths, $items) {
      var widths = inlineWidths.split(',');

      $.each($items, function (index) {
        if (index < widths.length) {
          $(this).width(widths[index] + '%');
        }
      });
    }
  };
})(jQuery);
